import type { LuckRow } from "@averagejoesff/shared";
import { formatRecord } from "../../lib/format";

export const recordText = (r: LuckRow["actual"]): string => formatRecord(r.wins, r.losses, r.ties);

/** "+2.6", "−1.5", "0.0": a change in wins, with a real minus sign. */
export function signed(n: number, digits = 0): string {
  const rounded = Number(n.toFixed(digits));
  if (rounded === 0) return (0).toFixed(digits);
  return `${rounded > 0 ? "+" : "−"}${Math.abs(rounded).toFixed(digits)}`;
}

/** Which way a change in wins reads: `good` for a gain, `bad` for a loss. */
export const tone = (n: number, epsilon = 0.05): "good" | "bad" | "even" => (n > epsilon ? "good" : n < -epsilon ? "bad" : "even");
